// $(document).ready(function(){
//     $('.custom_output').hide();
//     $("#modal-overlay").fadeIn();
//     $('.loading_data').show();
//     $('#modal-overlay').on('click', function(event) {
//         event.stopPropagation();
//     });
//     $.ajax({
//         url: 'https://mvpvisualsapi.matrixm.io/nrg-brand-orders/order-nrg-list.php',
//         type: 'GET',
//         dataType: 'json',   // yahan hona chahiye
//         success: function(json) {
//             $("#modal-overlay").fadeOut();
//             $('.loading_data').hide();
//             if(json.status == 'success'){
//                 $('.display_order_data').append(json.output);
//                 $('.pagination-order').append(json.pagination);
//             } else {
//                 $('.success_msg').text('There are some error into form');
//             }
//         },
//         error: function(xhr, status, error){
//             $("#modal-overlay").fadeOut();
//             $('.loading_data').hide();
//             console.log("AJAX Error:", error);
//             console.log(xhr.responseText);
//         }
//     });
// });



$(document).ready(function(){

    $('.custom_output').hide();

    $("#modal-overlay").fadeIn();

    $('.loading_data').show();
    
    $('#modal-overlay').on('click', function(event) {
        event.stopPropagation();
    });

    $.ajax({
        url: 'http://api.energymvpbranding.com/nrg-brand-orders/order-nrg-list.php',
        type: 'GET',
        dataType: 'json',
        cache: false,
        success: function(json) {
            if(json.status === 'success'){
                $('.display_order_data').html(json.output);       // append -> html
                $('.pagination-order').html(json.pagination);     // append -> html
            } else {
                $('.success_msg').text(json.message || 'Something went wrong');
            }
        },
        error: function(xhr, status, error){
            console.log("AJAX Error:", error);
            console.log(xhr.responseText);

            $('.success_msg').text('Server error, please try again');
        },
        complete: function(){
            $("#modal-overlay").fadeOut();
            $('.loading_data').hide();
        }
    });
});


$(document).on('click', '.view_order_details', function(e) {

  var data_order_id = $(this).attr('data-order-id');
  console.log('data_order_id--', data_order_id);
  var data_order_action = $(this).attr('data-order-action');
  console.log('data_order_action--', data_order_action);

  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "http://api.energymvpbranding.com/nrg-brand-orders/view-nrg-details.php",
      data: {
        order_id: data_order_id,
        action: data_order_action
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          $('.order-status-btn').html(response['btn_output']);
          $('.order_details_data').html(response['output']);
        }
      }
    });
  }
});

$(document).on('click', '.update_status', function(e) {
  var data_order_id = $(this).attr('data-order-id');
  var data_order_action = $(this).attr('data-order-action');
  var order_status = $(this).attr('data-order-status');
  var btn_ele = $(this);
  $('.order_loader').css('display', 'block');
  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "http://api.energymvpbranding.com/nrg-brand-orders/update_nrg_order.php",
      data: {
        order_id: data_order_id,
        order_status: order_status, 
        action: data_order_action
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          btn_ele.text(response['order_status']);
          btn_ele.prop('disabled', 'disabled');
          btn_ele.removeClass('update_status');
          // $('.order_loader').css('display', 'none');
          $('.order_success_msg').text(response['output']);
        }
      }
    });
  }
});  

$(document).on('click', '.update-notes', function(e) {

  var data_order_id = $('.order_id').val();

  var data_order_action = $('.order_action').val();

  var data_order_note = $('.order_note').val();
  
  if(data_order_id != '') {
    $.ajax({
      type: "POST",
      url: "http://api.energymvpbranding.com/nrg-brand-orders/update_nrg_order.php",
      data: {
        order_id: data_order_id,
        action: data_order_action,
        notes: data_order_note
      },
      dataType: "json",
      success: function(response) {
        if(response['status'] == 'success'){
          $('.order_success_msg').text(response['output']);
        }
      }
    });
  }
});  
  
$(document).on('click', '.pagination_link', function(e) {

  $("#modal-overlay").fadeIn();

  $('.loading_data').css('display', 'block');

  var data_info = $(this).attr('data-info');

  var data_rel = $(this).attr('data-rel');

  var data_store = $(this).attr('data-store');

  if(data_info != '') {
    
    $.ajax({
      type: "GET",
      url: "http://api.energymvpbranding.com/nrg-brand-orders/pagination-nrg.php",
      data: {
        page_info: data_info,
        rel: data_rel,
        url: data_store
      },
      dataType: "json",
      success: function(response) {
        if( response['prev'] != '' ) {
          $('button[data-rel="previous"]').attr('data-info', response['prev']);
          $('button[data-rel="previous"]').removeAttr('disabled');
        } else {
          $('button[data-rel="previous"]').attr('data-info', "");
          $('button[data-rel="previous"]').attr('disabled', 'disabled');
        }
        if( response['next'] != '' ) {
          $('button[data-rel="next"]').attr('data-info', response['next']);
          $('button[data-rel="next"]').removeAttr('disabled');
        } else {
          $('button[data-rel="next"]').attr('data-info', "");
          $('button[data-rel="next"]').attr('disabled', 'disabled');
        }
        if( response['html'] != '' ) {
          $("#modal-overlay").fadeOut();
          $('.loading_data').css('display', 'none');
          $('.display_order_data').html(response['html']);
        }
      }
    });
  }
}); 

$(document).ready(function() {
    // Open modal
$(document).on('click', '.open-modal', function(e) {  
    $("#custom-modal").fadeIn();
    $("#modal-overlay").fadeIn();
});

// Close modal
$(document).on('click', '#close-modal', function(e) {
    e.preventDefault();
    $("#custom-modal").fadeOut();
    $("#modal-overlay").fadeOut();
});

// Close modal when clicking outside of it
$(document).mouseup(function(e) {
    var modal = $("#custom-modal");
    var modal_notes = $("#custom-modal-notes");
    if (!modal.is(e.target) && modal.has(e.target).length === 0 && !modal_notes.is(e.target) && modal_notes.has(e.target).length === 0) {
        modal.fadeOut();
        $("#modal-overlay").fadeOut();
        $('.order_loader').css('display','none');
    }
    if (!modal_notes.is(e.target) && modal_notes.has(e.target).length === 0) {
        modal_notes.fadeOut();
    }
});

$(document).on('click', '.open-notes-modal', function(e) {  
    var order_id = $(this).attr('data-order-id');
    $('.order_id').val(order_id);
    $('.update-notes').attr('data-order-id', order_id);
    $("#custom-modal-notes").fadeIn();
    $("#modal-overlay").fadeIn();
});

// Close notes modal
$("#close-modal-notes").click(function(e) {
    e.preventDefault();
    $("#custom-modal-notes").fadeOut();
    $("#modal-overlay").fadeOut();
});
}); 